import React from 'react';
// import { Link } from 'react-router-dom';
// import { connect } from 'react-redux';
// import ReactLoading from 'react-loading';
// import ReactDOM from 'react-dom';
import InputMask from 'react-input-mask';
import {
  Button
} from "react-bootstrap";
import MessageCom from "layouts/Dashboard/Message";

class UserForm extends React.Component {
	constructor(props){
		super(props);
		this.state = {
			user: { 
				name: this.props.userPro.name 				|| '',
				email: this.props.userPro.email 			|| '',
				password:'', phone:this.props.userPro.phone || '',
				permission: this.props.userPro.permission 	|| 0,
				company_id: this.props.userPro.company_id   || null,
			},
		   	userError: {
		        nameError: this.props.userErrorPro.nameError   			|| '',
		        emailError: this.props.userErrorPro.emailError 			|| '',
		        passwordError: this.props.userErrorPro.passwordError 	|| '',
		        phoneError: this.props.userErrorPro.phoneError 			|| ''
		    },
		    submitted: false,
		    adminUser: this.props.adminUserPro	|| '',
		    formType: this.props.formTypePro 	|| '',
		    componentType: this.props.componentPro || '',
		};

		this.handleUser = this.handleUser.bind(this);
  		this.handleUserSubmit = this.handleUserSubmit.bind(this);
  		this.handleUserEditSubmit = this.handleUserEditSubmit.bind(this);
  		this.validate = this.validate.bind(this);

  		this.handleUserCheckBox = this.handleUserCheckBox.bind(this);
	}
	handleUser(e){
	    const { name, value } = e.target;
	    const userState = {...this.state.user};
	    userState[name] = value;
	    this.setState({user: userState});
	}
	handleUserSubmit(e){
	    e.preventDefault();
	    this.setState({ submitted: true }, function(){
	      const err = this.validate();
	      if (!err){
	      	this.props.handleUserSubmitParPro(this.state.user);
	      }
	    });
	}
	handleUserEditSubmit(e){
	    e.preventDefault();
	    this.setState({ submitted: true }, function(){
	      const err = this.validate();
	      if (!err){
	      	this.props.handleUserEditSubmitParPro(this.state.user);
	      }
	    });
	}
	validate(){
	    let   isError = false;
	    const errors = {
	      nameError:'',
	      emailError:'',
	      passwordError:'',
	      phoneError:''
	    };

	    if (this.state.user.name.length === 0 || this.state.user.name.trim() === '') {
	        isError = true;
	        errors.nameError = "Name is required.";
	    }

	    if (this.state.user.email.length === 0 || !(this.state.user.email.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)) ) {
	        isError = true;
	        errors.emailError = "Email is required & must be abc@example.com format.";
	    }

	    
	    if ((this.state.user.phone.length === 0) || !(this.state.user.phone.match(/^((\([0-9]{3}\))|[0-9]{3})[\s\-]?[\0-9]{3}[\s\-]?[0-9]{4}$/g)) ) {
	        isError = true;
	        errors.phoneError = "Phone is required & format must be 123-456-7890.";
	    }

	    if ( (this.state.user.password.length === 0 || this.state.user.password.trim() === '') && this.state.formType === 'add') {
	        isError = true;
	        errors.passwordError = "Password is required.";
	    }

	    this.setState({userError: errors}, function(){

	    });
	    return isError; 
	}
	handleUserCheckBox(e){
	    const { value } = e.target;
	    const userStatePer = {...this.state.user};
	    userStatePer['permission'] = value === 'on'?0:1;
	    this.setState({user: userStatePer}, function(){
	      console.log('userStatePer',this.state.user);
	    });
	}
	render(){
		const { user, userError, submitted, formType} = this.state;
		return(
			<form onSubmit={formType==='edit'?this.handleUserEditSubmit:this.handleUserSubmit}>
			  <div className="row">
			    <div className="col-md-6">
			      <div className={'form-group' + (submitted && userError.nameError!=='' ? ' has-error' : '')}>
			        <label htmlFor="name">Name</label>
			        <input type="text" name="name" className="form-control"  value={user.name} onChange={this.handleUser}/>
			        {
			          submitted && userError.nameError!=='' &&
			          <div className="help-block">{userError.nameError}</div>
			        }
			      </div>
			    </div>
			    <div className="col-md-6">
			      <div className={'form-group' + (submitted && userError.emailError!=='' ? ' has-error' : '')}>
			        <label htmlFor="email">Email</label>
			        <input type="text" name="email" className="form-control" value={user.email} onChange={this.handleUser} readOnly={formType === 'edit'?true:false} />
			        {
			          submitted && userError.emailError!=='' &&
			          <div className="help-block">{userError.emailError}</div>
			        }
			      </div>
			    </div>
			  </div>
			  <div className="row">
			    <div className="col-md-6">
			      <div className={'form-group' + (submitted && userError.phoneError!=='' ? ' has-error' : '')}>
			        <label htmlFor="Phone">Phone</label>
			        <InputMask  mask="999-999-9999" maskChar={null} type="text" name="phone" className="form-control" placeholder="123-456-7890" value={this.state.user.phone}  onChange={this.handleUser} />
			        {
			          submitted && userError.phoneError!=='' &&
			          <div className="help-block">{userError.phoneError}</div>
			        }
			      </div>
			    </div>
			    <div className="col-md-6">
			      <div className={'form-group' + (submitted && userError.passwordError!=='' ? ' has-error' : '')}>
			        <label htmlFor="password">Password</label>
			        <input type="password" name="password" className="form-control" value={user.password}  onChange={this.handleUser} minLength="6"/>
			        {
			          submitted && userError.passwordError!=='' &&
			          <div className="help-block">{userError.passwordError}</div>
			        }
			      </div>
			    </div>
			  </div>
			  {/*
                ((adminUser.type === 'admin') || (adminUser.type === 'company' && adminUser.user.permission === 1) ) && componentType === 'companyUser' &&
                <div className="row">
                  <div className="col-md-6">
                    <div className=''>
                      <label className="container-check"> Primary User
                        <input type="checkbox" name="permission" className="checkbox" value={user.permission?'on':'off'} checked={user.permission?true:false} onChange={this.handleUserCheckBox} />
                        <span className="checkmark"></span>
                      </label>
                    </div>
                  </div>
                </div>
              */
              }
			  <div className="row">
			    <div className="col-md-12">
			      <div className='btn-toolbar'>
			        <Button type='submit' bsSize="large" bsStyle="info" className="outOfTableButton" >Save</Button>
			        {
			        	formType === 'edit' &&
			        	<Button bsSize="large" bsStyle="info" onClick={()=>this.props.closeModalUserEditPro() } className="outOfTableButton" >Cancel</Button>
			        }
			        {
			        	formType === 'add' &&
			        	<Button bsSize="large" bsStyle="info" onClick={()=>this.props.closeModalUserPro() } className="outOfTableButton" >Cancel</Button>
			        }
			      </div>
			    </div>
			  </div>
			  <div className="row">
			    <div className="col-md-12">
			      <div>
			        <MessageCom/>
			      </div>
			    </div>
			  </div>
			</form>
		);
	}
}


export default UserForm;


// WEBPACK FOOTER //
// ./src/components/Admin/Users/UserForm.jsx